import React from 'react';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';

/**
 * Pioneer AppBar — wraps MUI AppBar with project defaults.
 *
 * Defaults:
 * - position="static" (Pioneer standard)
 * - elevation={0} (Pioneer standard, flat surface)
 *
 * All MUI AppBar props are supported and can override defaults.
 */
export interface AppBarProps extends MuiAppBarProps {}

const AppBar = React.forwardRef<React.ComponentRef<typeof MuiAppBar>, AppBarProps>(
  function AppBar(props, ref) {
    return <MuiAppBar position="static" elevation={0} ref={ref} {...props} />;
  },
);

export default AppBar;
